import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7399a743"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "content" }
const _hoisted_2 = { class: "preview_box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { style: {"height":"30px"} }, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode("回复")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_descriptions_item = _resolveComponent("a-descriptions-item")!
  const _component_a_image = _resolveComponent("a-image")!
  const _component_a_image_preview_group = _resolveComponent("a-image-preview-group")!
  const _component_a_descriptions = _resolveComponent("a-descriptions")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.detail)
      ? (_openBlock(), _createBlock(_component_a_card, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_a_descriptions, {
              title: "反馈信息",
              bordered: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_a_descriptions_item, { label: "用户" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.user?.nickname), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "联系方式" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.user?.mobile), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, { label: "反馈时间" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.create_date), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "反馈内容",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.detail?.content), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_a_descriptions_item, {
                  label: "图片",
                  span: 3
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (_ctx.detail?.images)
                        ? (_openBlock(), _createBlock(_component_a_image_preview_group, { key: 0 }, {
                            default: _withCtx(() => [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.images, (img, i) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  class: "preview_item",
                                  key: i
                                }, [
                                  _createVNode(_component_a_image, {
                                    src: img,
                                    width: 150,
                                    height: 150
                                  }, null, 8, ["src"])
                                ]))
                              }), 128))
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _hoisted_3,
            (_ctx.detail?.reply_list)
              ? (_openBlock(), _createBlock(_component_a_descriptions, {
                  key: 0,
                  title: "回复信息",
                  bordered: _ctx.detail?.reply_list?.length
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.detail?.reply_list, (item) => {
                      return (_openBlock(), _createBlock(_component_a_descriptions_item, {
                        label: `${item?.reply_user?.name}(${item.reply_date})`,
                        labelStyle: {width: '250px'},
                        span: 3
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.reply || '无'), 1)
                        ]),
                        _: 2
                      }, 1032, ["label"]))
                    }), 256))
                  ]),
                  _: 1
                }, 8, ["bordered"]))
              : _createCommentVNode("", true),
            _createElementVNode("div", null, [
              _createVNode(_component_a_textarea, {
                value: _ctx.reply,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.reply) = $event)),
                placeholder: "请输入回复内容",
                rows: 4
              }, null, 8, ["value"]),
              _createVNode(_component_a_button, {
                type: "primary",
                style: {"margin-top":"15px"},
                loading: _ctx.loading,
                onClick: _ctx.onReply
              }, {
                default: _withCtx(() => [
                  _hoisted_4
                ]),
                _: 1
              }, 8, ["loading", "onClick"])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}